import { RotateCcw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PredictiveAddressManager } from "./predictive-address-manager";

export const CallCounter = (predictiveManager: PredictiveAddressManager) => {
  return (
    <div className="flex items-center justify-center gap-4">
      <p className="text-sm">{`Call counter: ${predictiveManager.callCounter}`}</p>
      <p className="text-sm">
        {`Credit counter: ${predictiveManager.creditCounter.toLocaleString(
          "en-US",
          { minimumFractionDigits: 1 },
        )}`}
      </p>
      <Button
        variant="ghost"
        size="icon"
        className="size-6"
        onClick={() => {
          predictiveManager.setCallCounter(0);
          predictiveManager.setCreditCounter(0);
        }}
      >
        <RotateCcw className="size-4" />
      </Button>
    </div>
  );
};
